import React, { ReactNode, createContext, useContext } from 'react';
import { useGetBandshopConfigQuery } from 'services/cms';

type BandshopConfigContextType = BandshopItem;

const BandshopConfigContext = createContext<BandshopConfigContextType | undefined>(undefined);

export const BandshopConfigProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const { data } = useGetBandshopConfigQuery();

  if (!data?.items?.[0]) return null;

  return (
    <BandshopConfigContext.Provider value={data?.items[0]}>
      {children}
    </BandshopConfigContext.Provider>
  );
};

export const useBandshopConfig = (): BandshopConfigContextType => {
  const context = useContext(BandshopConfigContext);
  if (!context) throw new Error('useBandshopConfig must be used within a BandshopConfigProvider');
  return context;
};
